module.exports = __webpack_public_path__ + "img/factor_c_blue.4f3d1051.svg";